<template>
  <div id="app">
    <v-app v-cloak id="inspire">
      <import-alerts
        v-if="
          $store.state.user.user_infor &&
          $store.state.user.user_infor.has_business
        "
      ></import-alerts>

      <v-overlay
        :color="$vuetify.theme.isDark ? '#000000' : '#ffffff'"
        :value="$store.state.initializing_app"
        opacity="0.9"
      >
        <v-img
          class="ml-16 mr-16 mb-2 logo-animation"
          height="100px"
          src="data:image/png;base64,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"
          width="100px"
        ></v-img>
        <v-progress-linear
          :color="ProgressColor"
          :value="$store.state.init_state"
          height="5"
        >
        </v-progress-linear>
      </v-overlay>
      <v-dialog
        v-model="$store.state.idle_dialog"
        :fullscreen="$vuetify.breakpoint.mobile"
        opacity="0.7"
        persistent
        width="500"
      >
        <lite-login-component></lite-login-component>
      </v-dialog>

      <v-navigation-drawer
        v-if="
          $store.state.user.is_loged_in &&
          !$store.state.initializing_app &&
          currentBusiness
        "
        v-model="$store.state.side_bar"
        :class="$vuetify.breakpoint.mobile ? '' : 'transparent'"
        :clipped="false"
        app
        class="sidenav"
        id="sidenav"
        floating
        width="200px"
      >
        <businesses-selector></businesses-selector>

        <v-list
          v-if="$store.state.user_initialised"
          class="section"
          dense
          shaped
          style="margin-bottom: 350px; margin-top: 70px"
        >
          <template v-for="(item, index) in items">
            <v-layout v-if="item.heading" :key="item.heading" align-center row>
              <v-flex xs6>
                <v-subheader v-if="item.heading">
                  {{ item.heading }}
                </v-subheader>
              </v-flex>
              <v-flex class="text-xs-center" xs6>
                <a class="body-2 black--text" href="#!">{{
                  $t("main.edit")
                }}</a>
              </v-flex>
            </v-layout>

            <v-list-group
              v-else-if="item.children"
              :key="item.text"
              :id="item.id"
              v-model="item.model"
              :prepend-icon="item.preIcon ? item.preIcon : ''"
              :to="item.route"
              class="pt-0 pl-0"
              color="blue"
              style="text-decoration: none"
            >
              <template v-slot:activator>
                <v-list-item-content class="pt-0 pb-0">
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                :to="child.route"
                style="text-decoration: none"
              >
                <v-list-item-action>
                  <v-icon small>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content class="pt-0 pl-0">
                  <v-list-item-title>
                    {{ child.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <v-list-item
              active-class="linkActive"
              v-else-if="item.can"
              :id="item.id ? item.id : '#'"
              :key="item.route"
              :class="item.text == 'Settings' ? 'bottom-menu' : ''"
              :to="item.route"
              class="pt-0 pb-0"
              color="blue"
              dense
              style="text-decoration: none"
            >
              <v-list-item-content class="pt-0 pb-0 d-flex align-center">
                <v-list-item-title class="d-flex align-center">
                  <span class="mr-1"
                    ><v-icon small>{{ item.icon }}</v-icon></span
                  >
                  {{ item.text
                  }}<sup v-if="item.locked">
                    <v-icon x-small>mdi-lock-outline</v-icon>
                  </sup>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon v-if="item.main">
                <v-icon class="text--disabled" small>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
        </v-list>

        <v-list
          :class="$vuetify.theme.isDark ? 'black' : 'grey lighten-4'"
          dense
          shaped
          style="
            bottom: 0 !important;
            position: absolute;
            width: 100%;
            border-radius: 15px;
          "
        >
          <!--  SETTINGS BTN-->
          <v-list-item>
            <v-list-item-content>
              <ad-card></ad-card>
            </v-list-item-content>
          </v-list-item>

          <span id="builtAppsSideLink">
            <v-list-item
              @click="showAppsDialog = true"
              color="green"
              class="green--text rounded"
              style="background-color: rgba(0, 128, 0, 0.08)"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon small color="green" class="mr-1">mdi-apps</v-icon>
                  Built Apps</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </span>

          <v-list-item
            v-if="!showMenu"
            id="SettingsSidemenu"
            class="pb-0 pt-0 d-flex align-center"
            color="blue darken-4"
            to="/settings"
            style="text-decoration: none"
          >
            <v-list-item-content class="pb-0 pt-0">
              <v-list-item-title>
                <v-icon small class="mr-1">mdi-cog-outline</v-icon>
                {{ $t("main.settings")
                }}<sup v-if="EXPIRED">
                  <v-icon x-small>mdi-lock-outline</v-icon>
                </sup>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            id="MoreSidemenu"
            class="pb-0 pt-0 d-flex align-center"
            color="warning"
            style="text-decoration: none"
            @click="showMenu = true"
          >
            <v-list-item-content class="pb-0 pt-0" id="moreMenu">
              <v-list-item-title>
                <v-icon small class="mr-1">mdi-more</v-icon>
                {{ $t("main.more") }}
              </v-list-item-title>
            </v-list-item-content>
            <v-icon
              >{{ showMenu ? "mdi-chevron-down" : "mdi-chevron-up" }}
            </v-icon>
            <v-menu
              v-model="showMenu"
              :absolute="true"
              :allow-overflow="true"
              :close-on-content-click="false"
              attach="#sidenav"
              :position-y="convertToPixels"
              class="menuClass"
              fixed
              min-width="180"
              transition="slide-y-transition"
            >
              <v-sheet
                style="max-height: 50vh; overflow: auto; font-size: 0.7rem"
              >
                <v-list>
                  <v-list-item
                    id="AffiliateSidemenu"
                    class="pb-0 pt-0"
                    color="blue"
                    to="/developer"
                    @click="showMenu = false"
                    title="Developer Console"
                  >
                    <v-list-item-title>
                      <v-icon class="mr-1" small>mdi-xml</v-icon>
                      Developer Console
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    id="AffiliateSidemenu"
                    class="pb-0 pt-0"
                    color="success"
                    to="/affiliate"
                    @click="showMenu = false"
                    :title="$t('main.refer')"
                  >
                    <v-list-item-title>
                      <v-icon small class="mr-1">mdi-vector-link</v-icon>
                      {{ $t("main.refer") }}
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    id="download"
                    class="pb-0 pt-0 mb-2"
                    @click="downloadModal = true"
                    title="Download Built app"
                  >
                    <v-list-item-title>
                      <v-icon small class="mr-1"
                        >mdi-download-circle-outline</v-icon
                      >
                      Download Built app
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-sheet>
            </v-menu>
          </v-list-item>
        </v-list>

        <!--				DOWNLOAD MODAL-->
        <v-dialog v-model="downloadModal" width="500" class="overflow-y-hidden">
          <v-card class="mx-auto pa-5">
            <v-card-title class="fw-extrabold">
              Download the Built Mobile App
              <v-spacer></v-spacer>
              <v-btn @click="downloadModal = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-row align="center" justify="center" class="text-center mt-2">
              <v-col cols="12">
                <v-img
                  :src="require('../public/img/QR.png')"
                  height="250"
                  width="250"
                  class="mx-auto"
                ></v-img>
                <v-card-text
                  :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
                  class="fw-bold"
                >
                  Scan To Download the iOS or Android App
                </v-card-text>
              </v-col>
              <v-col cols="12" class="text-center"></v-col>
            </v-row>
            <v-row class="mb-4">
              <v-col cols="6">
                <a
                  href="https://play.google.com/store/apps/details?id=com.builtaccounting.app"
                  target="_blank"
                  style="cursor: pointer"
                >
                  <v-img
                    :src="require('../public/img/googlePlay.png')"
                    height="50"
                    width="150"
                    style="object-fit: contain"
                    class="mx-auto rounded shadow"
                  ></v-img>
                </a>
              </v-col>
              <v-col cols="6">
                <a
                  href="https://apps.apple.com/gh/app/built-accounting/id1547855525"
                  target="_blank"
                  style="cursor: pointer"
                >
                  <v-img
                    :src="require('../public/img/Group 89798.png')"
                    height="50"
                    width="150"
                    style="object-fit: contain"
                    class="mx-auto rounded shadow"
                  ></v-img>
                </a>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </v-navigation-drawer>

      <v-app-bar
        :color="$vuetify.theme.dark ? 'dark' : '#FBFBFB'"
        :height="72"
        v-if="
          $store.state.user.user_infor &&
          $store.state.user.user_infor.has_business &&
          $store.state.user.is_loged_in
        "
        :clipped-left="false"
        app
        elevate-on-scroll
        flat
        id="appBar"
      >
        <v-toolbar-title v-if="!$vuetify.breakpoint.mobile">
          <v-btn
            style="transition: 0.5s ease-in-out"
            icon
            @click.stop="$store.state.side_bar = !$store.state.side_bar"
          >
            <v-icon style="transition: 0.5s ease-in-out" large>
              {{ !$store.state.side_bar ? "mdi-menu" : "mdi-menu-open" }}
            </v-icon>
          </v-btn>
          <!--          <v-app-bar-nav-icon-->
          <!--            @click.stop="$store.state.side_bar = !$store.state.side_bar"-->
          <!--          >-->
          <!--            mdi-chevron-left-->
          <!--          </v-app-bar-nav-icon>-->
        </v-toolbar-title>
        <v-row align="center" dense>
          <v-col cols="1" v-if="$vuetify.breakpoint.mobile">
            <v-app-bar-nav-icon
              v-if="$vuetify.breakpoint.mobile"
              @click.stop="$store.state.side_bar = !$store.state.side_bar"
            ></v-app-bar-nav-icon>
          </v-col>
          <v-col
            :cols="$vuetify.breakpoint.mobile ? 6 : 7"
            class="d-flex align-center"
          >
            <v-img
              width="100"
              class="mr-md-4"
              contain
              v-if="
                $store.state.user.user_infor.current_business.partner &&
                $store.state.user.user_infor.current_business.partner.logo &&
                !$vuetify.breakpoint.mobile
              "
              :src="$store.state.user.user_infor.current_business.partner.logo"
            ></v-img>
            <v-spacer></v-spacer>
            <!-- <search style="width: 100% !important" v-if="!EXPIRED"></search> -->
            <general-search
              style="width: 100% !important"
              v-if="!EXPIRED"
            ></general-search>
            <!--						$store.state.user.user_infor.has_business-->
            <subscription-alert-component
              v-if="true"
            ></subscription-alert-component>
          </v-col>

          <!--          <v-spacer></v-spacer>-->

          <v-col cols="5" class="d-flex align-center justify-end pl-5">
            <v-menu top :offset-y="offset" transition="slide-y-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :color="$vuetify.theme.dark ? 'white' : 'blue'"
                  class="white--text d-flex align-center fw-extrabold justify-space-between mr-3 text-capitalize"
                  small
                  outlined
                  rounded
                  style="font-size: 0.9rem"
                  ><span
                    ><v-icon
                      :color="$vuetify.theme.dark ? 'white' : 'blue'"
                      small
                      v-if="!$vuetify.breakpoint.mobile"
                      >mdi-plus-box-multiple-outline</v-icon
                    ></span
                  >{{ !$vuetify.breakpoint.mobile ? "Create" : "" }} New
                  <span
                    ><v-icon
                      :color="$vuetify.theme.dark ? 'white' : 'blue'"
                      small
                      >mdi-menu-down</v-icon
                    ></span
                  ></v-btn
                >
              </template>

              <v-list>
                <v-list-item
                  style="text-decoration: none"
                  v-for="(item, index) in menuItems"
                  v-if="item.visible"
                  :key="index"
                  :to="!item.url ? item.link : ''"
                  :href="item.url ? item.link : ''"
                  :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
                  :target="item.url ? '_blank' : ''"
                  :rel="item.url ? 'noopener noreferrer' : ''"
                >
                  <v-sheet
                    :color="item.color + ' lighten-5'"
                    rounded
                    class="pa-1"
                  >
                    <v-icon :color="item.color + ' darken-5'"
                      >{{ item.icon }}
                    </v-icon>
                  </v-sheet>
                  <v-list-item-title class="ml-1"
                    >{{ item.text }}
                    <v-icon v-if="item.external" x-small
                      >mdi-open-in-new
                    </v-icon>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <notifications-component></notifications-component>

            <v-btn
              v-if="
                $store.state.user.user_infor.has_business &&
                !$vuetify.breakpoint.mobile
              "
              v-show="basicOrTrial"
              color="green lighten-5 green--text "
              depressed
              rounded
              to="/plans"
              >{{ $t("main.upgrade") }}
            </v-btn>

            <v-menu
              bottom
              max-width="300"
              min-width="300"
              origin="center center"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on }">
                <v-btn id="userAvatar" large rounded small text v-on="on">
                  <v-avatar
                    v-if="$store.state.user.user_infor.photo"
                    item
                    size="32px"
                  >
                    <v-img :src="$store.state.user.user_infor.photo"></v-img>
                  </v-avatar>
                  <avatar-component
                    v-else
                    :label="$store.state.user.user_infor.first_name"
                    size="35"
                  ></avatar-component>

                  <span
                    v-if="!$vuetify.breakpoint.mobile"
                    class="trim-text-no-padding"
                  >
                    {{ $store.state.user.user_infor.first_name }}
                  </span>
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>

              <v-card class="change_log">
                <v-list>
                  <v-list-item>
                    <v-list-item-avatar>
                      <v-avatar
                        v-if="$store.state.user.user_infor.photo"
                        item
                        size="32px"
                      >
                        <v-img
                          :src="$store.state.user.user_infor.photo"
                        ></v-img>
                      </v-avatar>
                      <avatar-component
                        v-else
                        :label="$store.state.user.user_infor.first_name"
                        size="35"
                      ></avatar-component>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title
                        >{{ $store.state.user.user_infor.first_name }}
                        {{ $store.state.user.user_infor.last_name }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ $store.state.user.user_infor.email }} <br />
                        <span
                          v-if="$store.state.user.user_infor.is_admin == 1"
                          class="green--text"
                        >
                          <v-icon color="green">mdi-check</v-icon>
                          {{ $t("main.admin") }}
                        </span>
                        <span v-else class="text-muted">
                          {{ $t("main.user") }}
                        </span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <v-divider></v-divider>

                <v-list>
                  <v-list-item
                    style="text-decoration: none"
                    to="/usersettings"
                    class="font-weight-bold"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-icon
                          :color="$vuetify.theme.isDark ? 'white' : 'black'"
                          class="mr-1"
                        >
                          mdi-account-settings
                        </v-icon>
                        {{ $t("main.user") }}
                        {{ $t("main.settings") }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon class="black--text">mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                  <!--THEME CHANGER-->
                  <v-list-item
                    :class="{
                      'hover-effect-light': hover && !$vuetify.theme.dark,
                      'hover-effect-dark': hover && $vuetify.theme.dark,
                    }"
                    @mouseover="hover = true"
                    @mouseleave="hover = false"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        @click="toggleTheme"
                        style="cursor: pointer"
                        class="d-flex align-center font-weight-bold"
                        :class="{
                          'white--text': $vuetify.theme.isDark,
                          'black--text': !$vuetify.theme.isDark,
                        }"
                      >
                        <v-icon
                          :color="$vuetify.theme.isDark ? 'white' : 'black'"
                          class="mr-2"
                          >{{
                            $vuetify.theme.isDark
                              ? "mdi-lightbulb-on-10"
                              : "mdi-weather-night"
                          }}
                        </v-icon>
                        {{
                          $vuetify.theme.isDark ? "Light Theme" : "Dark Theme"
                        }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <!--                  <v-list-item class="my-1">-->
                  <!--                    <LanguagesComponents></LanguagesComponents>-->
                  <!--                  </v-list-item>-->
                </v-list>

                <v-card-actions>
                  <v-btn block color="red" text @click="logout_dialog = true"
                    >{{ $t("main.logout") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
      </v-app-bar>

      <v-snackbar v-model="error_message" color="error">
        {{ error_msg }}
      </v-snackbar>
      <v-snackbar v-model="success_message">
        {{ toast_msg }}
      </v-snackbar>

      <v-dialog v-model="switch_dialog" persistent width="450px">
        <v-card>
          <v-card-text class="p-2">
            {{ $t("main.business_change_message") }}
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-4" text @click="setactive"
              >{{ $t("main.switch") }}
            </v-btn>
            <v-btn
              text
              @click="
                switch_dialog = !switch_dialog;
                init_user();
              "
              >{{ $t("main.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div v-if="$store.state.user.is_loged_in" id="innerContainer">
        <v-dialog v-model="$store.state.global_error" persistent width="400">
          <v-card>
            <v-card-title>{{ $t("main.state_changed") }}</v-card-title>
            <v-card-text>
              <h4>{{ $store.state.global_error_message }}</h4>
              <small>
                {{ $t("main.state_changed_message") }}
              </small>
              <v-btn
                block
                color="blue darken-4"
                dark
                rounded
                depressed
                @click="reload_page()"
                >{{ $t("main.ok") }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-cloak v-model="logout_dialog" width="450">
          <v-card>
            <v-card-title class="text-danger"
              >{{ $t("main.confirm_logout") }}
            </v-card-title>
            <v-card-text>
              <h5>{{ $t("main.logout_message") }}</h5>
            </v-card-text>
            <v-card-actions>
              <v-btn
                :loading="progress"
                block
                color="red"
                dark
                depressed
                rounded
                x-large
                @click="logout()"
              >
                {{ $t("main.logout") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <v-main
        :class="$vuetify.theme.isDark ? 'bg-black' : 'bg-light'"
        style="height: 100% !important; width: 100%"
      >
        <v-container fluid style="height: 100% !important">
          <alert-banner
            :currentRoute="currentRoute"
            v-show="currentRoute"
          ></alert-banner>

          <div v-if="$store.state.user.is_loged_in">
            <div v-if="$store.state.user.user_infor.has_business">
              <upgrade-component
                v-if="
                  $store.state.user.user_infor.current_business.subscription
                    .name == 'basic' && !INVITED_AND_EXPIRED
                "
                v-show="$route.name === 'Home'"
                upgrade-type="default"
              ></upgrade-component>
            </div>

            <confirm-warning
              v-if="
                !$store.state.user.user_infor.email_verified_at &&
                $store.state.user.user_infor &&
                $store.state.user.user_infor.has_business
              "
            ></confirm-warning>

            <announcement-bar></announcement-bar>

            <v-snackbar
              v-model="$store.state.networkStatus.show"
              :color="$store.state.networkStatus.color"
              :timeout="$store.state.networkStatus.timeOut"
              bottom
              dark
              left
            >
              <v-icon v-if="$store.state.networkStatus.color === 'green'"
                >mdi-network-strength-4
              </v-icon>

              <v-icon v-if="$store.state.networkStatus.color === 'warning'"
                >mdi-network-strength-2-alert
              </v-icon>
              <v-icon v-if="$store.state.networkStatus.color === 'red'"
                >mdi-network-strength-off
              </v-icon>

              {{ $store.state.networkStatus.message }}

              <v-btn
                v-if="
                  $store.state.networkStatus.color === 'green' ||
                  $store.state.networkStatus.color === 'warning'
                "
                class="m-2"
                icon
                @click="$store.state.networkStatus.show = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-snackbar>
          </div>

          <general-error-component></general-error-component>

          <component-loading></component-loading>

          <router-view
            v-if="!$store.state.initializing_app && !INVITED_AND_EXPIRED"
          ></router-view>

          <business-expired-guard
            v-if="!$store.state.initializing_app && INVITED_AND_EXPIRED"
          ></business-expired-guard>

          <shortcutMenuComponent
            v-if="$vuetify.breakpoint.mobile && $store.state.user.is_loged_in"
          >
          </shortcutMenuComponent>

          <business-activation
            v-if="$store.state.user.is_loged_in"
            :isOpen="toggleBusiness"
            @close="() => (toggleBusiness = false)"
          ></business-activation>
        </v-container>
      </v-main>
    </v-app>

    <share-sheet-alert
      v-if="
        !$store.state.initializing_app &&
        $store.state.user.is_loged_in &&
        $store.state.user.user_infor.has_business &&
        !$vuetify.breakpoint.mobile
      "
    ></share-sheet-alert>

    <v-dialog
      v-if="
        !$store.state.initializing_app &&
        $store.state.user.is_loged_in &&
        $store.state.user.user_infor.has_business
      "
      v-model="$store.state.showOnboarding"
      fullscreen
      persistent
      eager
      transition="dialog-bottom-transition"
    >
      <v-card
        v-if="$store.state.showOnboarding"
        :class="$vuetify.theme.isDark ? 'black' : 'grey lighten-5'"
      >
        <v-card-text>
          <main-onboarding-component></main-onboarding-component>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showAppsDialog" width="500">
      <v-card>
        <v-card-title></v-card-title>
        <AppCardComponent></AppCardComponent>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import shortcutMenuComponent from "./components/patials/shortcutMenuComponent";
import ImportAlerts from "./components/importAlerts/ImportAlerts.vue";
import { store } from "./store";
import LanguagesComponents from "./components/patials/LanguagesComponents";
import AddShortcut from "./components/addShortcut";
import ConfirmWarning from "./components/patials/confirmWarning";
import NotificationsComponent from "./components/patials/notificationsComponent";
import AnnouncementBar from "./components/announcement/AnnouncementBar";
import AppTour from "./components/tour/appTour";
import router from "./router";
import ComponentLoading from "./components/patials/componentLoading";
import SideDrawerTour from "./components/tour/SideDrawerTour.vue";
import Search from "./components/AppSearch/Search";
import BusinessExpiredGuard from "./components/patials/BusinessExpiredGuard";
import GeneralErrorComponent from "./components/patials/GeneralErrorComponent";
import AvatarComponent from "./components/agents/avatarComponent";
import AppsMenu from "./components/patials/AppsMenu";
import TourComponent from "./components/tour/TourComponent";
import POSAlert from "./components/announcement/POSAlert";
import ShareSheetAlert from "./components/announcement/shareSheetAlert";
import LiteLoginComponent from "./components/agents/LiteLoginComponent";
import UpgradeComponent from "./components/patials/upgradeComponent";
import BusinessesSelector from "./components/patials/BusinessesSelector";
import PromoAnnouncer from "./components/promo/promoAnnouncer";
import moment from "moment";
import TeamAvarters from "./components/patials/teamAvarters";
import MainOnboardingComponent from "./components/onboarding/MainOnboardingComponent";
import SubscriptionAlertComponent from "./components/patials/subscriptionAlertComponent";
import { getAccessToken, setAccessToken } from "./utils";
import axios from "axios";
import AppCardComponent from "./components/dashboard/AppCardComponent.vue";
import AlertBanner from "./components/alertbanner/AlertBanner.vue";
import AdCard from "./components/patials/AdCard.vue";
import GeneralSearch from "./components/GeneralSearch/Search.vue";

const BusinessActivation = () =>
  import("./components/toggleBusinessActivation");

export default {
  name: "App",
  components: {
    AdCard,
    AppCardComponent,
    SubscriptionAlertComponent,
    MainOnboardingComponent,
    TeamAvarters,
    PromoAnnouncer,
    BusinessesSelector,
    UpgradeComponent,
    LiteLoginComponent,
    ShareSheetAlert,
    POSAlert,
    TourComponent,
    AppsMenu,
    AvatarComponent,
    GeneralErrorComponent,
    BusinessExpiredGuard,
    Search,
    ComponentLoading,
    AppTour,
    AnnouncementBar,
    NotificationsComponent,
    ConfirmWarning,
    AddShortcut,
    LanguagesComponents,
    shortcutMenuComponent,
    BusinessActivation,
    SideDrawerTour,
    AlertBanner,
    ImportAlerts,
    GeneralSearch,
  },
  data() {
    return {
      showAppsDialog: false,
      offset: true,
      platform: null,
      platforms: [
        "Salesperson from Built",
        "Facebook Post",
        "YouTube Advert",
        "Blog Post",
        "Google Search",
        "A Friend",
        "Co-worker",
        "Twitter",
        "Linkedin",
        "WhatsApp",
        "E-Mail",
        "Radio",
        "TV",
        "News Paper",
        "I cannot Remember",
        "Others",
      ],
      referral_dialog: false,
      window: null,
      mobileType: null,
      isOnMobile: false,
      progress: false,
      e6: 1,
      idle_dialog: false,
      has_business: false,
      business_menu: false,
      toast_msg: "",
      success_message: false,
      error_message: false,
      error_msg: "",
      business: {},
      dialog: false,
      toggleBusiness: false,
      drawer: null,
      payrollCountries: ["GH", "KE", "SL"],
      logout_dialog: false,

      showMenu: false,
      switch_dialog: false,
      downloadModal: false,
      hover: false,
      allowedRoutes: [
        "developer",
        "developerHome",
        "developerWebhooks",
        "crm",
        "CRMDashboard",
        "CRMDashboardAlt",
        "CrmConversations",
        "CrmConversationsAlt",
        "CRMContacts",
        "BroadcastRoute",
        "CrmSettings",
        "SMSMessageView",
        "Wallet",
        "paymentLinks",
        "paymentLink",
        "virtualCards",
        "virtualCards",
        "virtualCardsPreview",
        "walletPayment",
        "walletPayPage",
        "walletBankTransfer",
        "walletTopup",
        "walletSettings",
        "walletSettingsMenu",
        "walletSettingsProfile",
        "walletSettingsAccounts",
        "walletSettingsSecurity",
        "walletServices",
        "walletServicesMenu",
        "walletServices",
        "walletTransactions",
        "walletTransaction",
        "Offerbox",
        "OfferboxPolicies",
        "OfferboxPoliciesDashboard",
        "OfferboxPoliciesOrders",
        "OfferboxPoliciesClaims",
        "OfferboxPoliciesClaim",
        "OfferboxPoliciesView",
        "OfferboxPoliciesOrder",
        "offer-box-detail",
        "insurance-details",
        "userSettings",
        "affiliate",
      ],
    };
  },

  computed: {
    currentRoute() {
      return this.$route.name;
    },
    announce_promo() {
      const startDate = moment("1/02/2023", "DD/MM/YYYY");
      const endDate = moment("28/02/2023", "DD/MM/YYYY");

      return moment().isBetween(startDate, endDate);
    },

    APP_STATE() {
      return this.$store.state.init_state;
    },

    CAN_SEE_WALLET() {
      return (
        this.currentBusiness &&
        [81, 113].includes(this.currentBusiness.country_id) &&
        this.current_user.is_admin &&
        ["GHS", "KES"].includes(this.currentBusiness.currency.code)
      );
    },
    INVITED_AND_EXPIRED() {
      if (
        this.user.is_loged_in &&
        this.user.user_infor &&
        this.user.user_infor.current_business &&
        this.user.user_infor.current_business.subscription.name === "none" &&
        !this.allowedRoutes.includes(this.$route.name)
      ) {
        return true;
      } else {
        return (
          this.user.is_loged_in &&
          this.user.user_infor &&
          this.user.user_infor.current_business &&
          !this.user.user_infor.is_admin &&
          this.user.user_infor.current_business.subscription.name === "basic" &&
          !this.allowedRoutes.includes(this.$route.name)
        );
      }
    },
    EXPIRED() {
      if (
        this.user.is_loged_in &&
        this.user.user_infor &&
        this.user.user_infor.current_business &&
        this.user.user_infor.current_business.subscription.name === "none"
      ) {
        return true;
      } else {
        return (
          this.user.is_loged_in &&
          this.user.user_infor &&
          this.user.user_infor.current_business &&
          !this.user.user_infor.is_admin &&
          this.user.user_infor.current_business.subscription.name === "basic"
        );
      }
    },
    convertToPixels() {
      // get window viewport dimensions
      return (80 * window.innerHeight) / 100;
    },
    basicOrTrial() {
      return (
        this.$store.state.user.user_infor.current_business.subscription.name ==
          "basic" ||
        this.$store.state.user.user_infor.current_business.subscription.name ==
          "trial"
      );
    },
    menuItems() {
      return [
        {
          text: "Invoice A Customer",
          icon: "mdi-receipt-text-plus",
          link: "/income/invoices/new",
          color: "blue",
          visible: true,
          external: false,
        },
        {
          text: "Raise A Bill",
          icon: "mdi-file-document-plus-outline",
          link: "/expense/expenses/newbill",
          color: "teal",
          visible: true,
          external: false,
        },
        {
          text: "Record An Expense",
          icon: "mdi-cash-minus",
          link: "/expense/paidexpenses",
          color: "blue-grey",
          visible: true,
          external: false,
        },
        {
          text: "Launch POS",
          icon: "mdi-printer-pos",
          url: true,
          link: "https://pos.built.africa/?s=" + getAccessToken(),
          color: "indigo",
          visible: true,
          external: true,
        },
        {
          text: "Run Payroll",
          icon: "mdi-account-group",
          link: "https://mypayroll.built.africa/?s=" + getAccessToken(),
          url: true,
          color: "purple",
          visible:
            this.currentBusiness &&
            this.payrollCountries.includes(this.currentBusiness.country.code),
          external: true,
        },
        {
          text: "Access Loan",
          icon: "mdi-account-cash",
          link: "/offerbox",
          color: "cyan",
          visible:
            this.currentBusiness &&
            this.payrollCountries.includes(this.currentBusiness.country_id),
          external: false,
        },
      ];
    },
    items() {
      if (!this.$store.state.user.user_infor.has_business) {
        return [];
      }
      return [
        {
          locked: this.EXPIRED,
          can: true,
          icon: "mdi-view-dashboard-outline",
          text: this.$t("main.side_bar.dashboard"),
          route: "/",
          active: true,
          id: "dashboardSidemenu",
          main: false,
        },

        {
          locked: this.EXPIRED,
          can: true,
          icon: "mdi-cash-multiple",
          "icon-alt": "keyboard_arrow_down",
          preIcon: "mdi-cash",
          text: this.$t("main.side_bar.income"),
          model: false,
          route: "/income",
          active: false,
          id: "incomeSidemenu",
          main: true,
        },

        {
          locked: this.EXPIRED,
          icon: "mdi-cash-minus",
          text: this.$t("main.side_bar.expenses"),
          model: false,
          active: false,
          route: "/expense",
          can: true,
          id: "expenseSidemenu",
          main: true,
        },
        {
          locked: false,
          can: this.CAN_SEE_WALLET,
          icon: "mdi-wallet-outline",
          "icon-alt": "keyboard_arrow_down",
          preIcon: "mdi-file",
          text: this.$t("main.side_bar.wallet"),
          route: "/wallet",
          model: false,
          id: "WalletSidemenu",
          main: false,
        },

        {
          locked: this.EXPIRED,
          can: true,
          icon: "mdi-cube-outline",
          text: this.$t("main.side_bar.products"),
          route: "/inventory",
          active: true,
          id: "productsSidemenu",
          main: false,
        },
        {
          locked: false,
          can:
            this.currentBusiness &&
            [81, 194].includes(this.currentBusiness.country_id),
          icon: "mdi-bank-outline",
          "icon-alt": "keyboard_arrow_down",
          preIcon: "mdi-file",
          text: this.$t("main.side_bar.finance"),
          route: "/offerbox",
          model: false,
          id: "financeSidemenu",
          main: false,
        },
        {
          locked: false,
          can: ["GH"].includes(
            this.$store.state.user.user_infor.current_business.country.code
          ),
          route: "/crm",
          icon: "mdi-bullhorn-outline",
          "icon-alt": "keyboard_arrow_down",
          preIcon: "mdi-account-multiple-outline",
          text: "CRM",
          model: false,
          active: false,
          id: "crmMenuItem",
          main: true,
        },
        {
          locked: this.EXPIRED,
          can: true,
          route: "/accounting",
          icon: "mdi-scale-balance",
          "icon-alt": "keyboard_arrow_down",
          preIcon: "mdi-calculator",
          text: this.$t("main.side_bar.accounting"),
          model: false,
          active: false,
          id: "accountingSidemenu",
          main: true,
        },
        {
          locked: this.EXPIRED,
          can: true,
          icon: "mdi-file-document-multiple-outline",
          text: this.$t("main.side_bar.reports"),
          route: "/reports",
          model: false,
          id: "ReportsSidemenu",
          main: true,
        },
        {
          locked: this.EXPIRED,
          can: false,
          icon: "mdi-cog-outline",
          text: this.$t("main.side_bar.settings"),
          route: "/settings",
          active: false,
          id: "SettingsSidemenu",
          main: false,
        },
      ];
    },
    /**
     * @return {boolean}
     */
    CAN_VIEW_SETTINGS() {
      return (
        this.$store.state.user.user_infor.is_admin === 1 ||
        this.$store.state.user.user_infor.invite.accountant_id !== null
      );
    },
    create_first_business() {
      return (
        !this.$store.state.user.user_infor.has_business &&
        this.$store.state.user.is_loged_in
      );
    },
    new_text() {
      return this.$t("main.new");
    },
    locale() {
      return this.$store.state.locale;
    },
    canShowAndroid() {
      return this.isOnMobile && this.mobileType === "Android";
    },
    mobileTarget() {
      return this.canShowAndroid
        ? "https://play.google.com/store/apps/details?id=com.builtaccounting.app"
        : "";
    },
    currentBusiness() {
      return this.$store.state.user.user_infor.current_business;
    },
    baseUrl() {
      return this.$store.state.baseURL;
    },
    init_change() {
      return this.$store.state.user_initialised;
    },
    windowsize() {
      return window.innerWidth;
    },
    user() {
      return this.$store.state.user;
    },
    current_user() {
      return this.$store.state.user.user_infor;
    },

    ProgressColor() {
      let color = "yellow";

      if (this.$store.state.init_state > 20) {
        color = "blue darken-4";
      } else if (this.$store.state.init_state > 60) {
        color = "green";
      }

      return color;
    },
    svgTextStyle() {
      return this.$vuetify.theme.dark ? "svg text { fill: white; }" : "";
    },
  },
  watch: {
    APP_STATE() {
      if (this.APP_STATE >= 100) {
        this.initItercom();
      }
    },

    locale() {
      this.$router.replace({ params: { lang: this.locale } }).catch(() => {});
    },

    init_change(oldvalue, newvalue) {
      let i = 0;

      this.items.forEach((nav) => {
        if (this.$store.state.user.user_infor.is_admin == 0) {
          if (i == 3) {
            nav.can =
              this.$store.state.user.user_infor.components[5].roles.view == 0
                ? false
                : true;
          }

          if (nav.text === "Settings") {
            nav.can = false;
          }

          if (nav.children) {
            if (nav.text == "Income") {
              let n = 0;
              nav.children.forEach((child) => {
                if (n == 0) {
                  child.can =
                    this.$store.state.user.user_infor.components[2].roles
                      .view == 0
                      ? false
                      : true;
                }

                if (n == 1) {
                  child.can =
                    this.$store.state.user.user_infor.components[0].roles
                      .view == 0 &&
                    this.$store.state.user.user_infor.components[1].roles
                      .view == 0
                      ? false
                      : true;
                }

                if (n == 2) {
                  child.can =
                    this.$store.state.user.user_infor.components[3].roles
                      .view == 0
                      ? false
                      : true;
                }
                if (n == 3) {
                  child.can =
                    this.$store.state.user.user_infor.components[4].roles
                      .view == 0
                      ? false
                      : true;
                }
                n++;
              });
            } else if (nav.text == "Expenses") {
              let n = 0;
              nav.children.forEach((child) => {
                if (n == 0) {
                  child.can = !(
                    this.$store.state.user.user_infor.components[6].roles
                      .view == 0 &&
                    this.$store.state.user.user_infor.components[7].roles
                      .view == 0
                  );
                }

                if (n == 1) {
                  child.can =
                    this.$store.state.user.user_infor.components[9].roles
                      .view == 0
                      ? false
                      : true;
                }

                if (n == 2) {
                  child.can =
                    this.$store.state.user.user_infor.components[8].roles
                      .view == 0
                      ? false
                      : true;
                }

                n++;
              });
            } else if (nav.text == "Accounting") {
              let n = 0;
              nav.children.forEach((child) => {
                if (n == 0) {
                  child.can =
                    this.$store.state.user.user_infor.components[11].roles
                      .view == 0
                      ? false
                      : true;
                }

                if (n == 1) {
                  child.can =
                    this.$store.state.user.user_infor.components[10].roles
                      .view == 0
                      ? false
                      : true;
                }
                n++;
              });
            } else if (nav.text == "Reports") {
              let n = 0;
              nav.children.forEach((child) => {
                if (n == 0) {
                  child.can =
                    this.$store.state.user.user_infor.components[15].roles
                      .view == 0
                      ? false
                      : true;
                }

                if (n == 1) {
                  child.can =
                    this.$store.state.user.user_infor.components[14].roles
                      .view == 0
                      ? false
                      : true;
                }
                if (n == 2) {
                  child.can =
                    this.$store.state.user.user_infor.components[16].roles
                      .view == 0
                      ? false
                      : true;
                }

                if (n == 3) {
                  child.can =
                    this.$store.state.user.user_infor.components[17].roles
                      .view == 0
                      ? false
                      : true;
                }

                if (n == 4) {
                  child.can =
                    this.$store.state.user.user_infor.components[13].roles
                      .view == 0
                      ? false
                      : true;
                }

                if (n == 5) {
                  child.can =
                    this.$store.state.user.user_infor.components[12].roles
                      .view == 0
                      ? false
                      : true;
                }

                n++;
              });
            }
          }
        }
        i++;
      });
    },
  },
  methods: {
    initItercom() {
      this.$intercom.boot({
        user_id: this.$store.state.user.user_infor.has_business
          ? this.$store.state.user.user_infor.id +
            "-" +
            this.$store.state.user.user_infor.current_business.country_id +
            "-" +
            this.$store.state.user.user_infor.current_business.id
          : this.$store.state.user.user_infor.id + "-NOB",
        name: this.$store.state.user.user_infor
          ? this.$store.state.user.user_infor.first_name +
            " " +
            this.$store.state.user.user_infor.last_name
          : "User",
        email: this.$store.state.user.user_infor.email,
        phone: this.$store.state.user.user_infor.phone_number,
      });

      //  if (this.$store.state.user.user_infor.has_business && this.$store.state.user.user_infor.current_business.country_id==81){
      //  this.$intercom.show();
      // // this.$intercom.showArticle(6911709);
      //    Intercom('showArticle', 6911709);
      //  //  this.$intercom('showArticle', 6911709);
      //  }
    },

    /**
     * this method tracks user idle time and log them out after 30 minutes
     */

    idleLogout() {
      window.onload = resetTimer;
      window.onmousemove = resetTimer;
      window.onmousedown = resetTimer; // catches touchscreen presses as well
      window.ontouchstart = resetTimer; // catches touchscreen swipes as well
      window.onclick = resetTimer; // catches touchpad clicks as well
      window.onkeydown = resetTimer;
      window.addEventListener("scroll", resetTimer, true);

      function timeup() {
        if (
          window.location.pathname !== "/auth/login" &&
          window.location.pathname !== "/auth/signup" &&
          !store.state.idle_dialog
        ) {
          axios

            .get("/api/auth/logout")
            .then((res) => {
              store.state.idle_dialog = true;
            })
            .catch((error) => {});
        }
      }

      function resetTimer() {
        const channel = new BroadcastChannel("sessionChannel");

        channel.postMessage({
          resetSession: true,
        });

        clearTimeout(store.state.idleTimer);

        store.state.idleTimer = setTimeout(timeup, 1_800_000); // time is in milliseconds
      }
    },

    reload_page() {
      window.location.reload();
    },

    g_new_income() {
      this.$store.state.new_income = true;
    },
    g_new_item() {
      this.$store.state.new_item = true;
    },
    g_new_expense() {
      this.$store.state.new_expense = true;
    },
    g_new_customer() {
      this.$store.state.new_customer = true;
    },
    g_new_supplier() {
      this.$store.state.new_supplier = true;
    },

    resend_verirfication() {
      this.progress = true;
      axios
        .get("/api/sendverify")
        .then((res) => {
          this.progress = false;
          this.toast_msg =
            "Email verification sent, please check your inbox to verify your account";
          this.success_message = true;
        })
        .catch(() => {
          this.progress = false;

          // this.error_msg = "Something went wrong, please try again";
          // this.error_message = true;
        });
    },

    logout() {
      this.progress = true;

      axios.get("/api/auth/logout").then((res) => {
        this.$store.state.user = null;
        setAccessToken(undefined);
        this.$store.state.initializing_app = true;
        this.$router.push({ path: "/auth/login" });

        this.progress = false;
        location.reload();
        this.logout_dialog = false;

        const logoutChannel = new BroadcastChannel("logoutConfirmed");

        logoutChannel.postMessage({
          logoutConfirmed: true,
        });
      });
    },
    switch_ui() {
      localStorage.isDark = this.$vuetify.theme.isDark;
    },

    toggleTheme() {
      this.$vuetify.theme.isDark = !this.$vuetify.theme.isDark;
      this.switch_ui();
    },

    getAddressData(addressData, placeResultData, id) {
      if (addressData) {
        this.business_location =
          addressData.longitude + "," + addressData.latitude;
      }
    },

    setactive() {
      axios
        .get("/api/activatebusiness/" + this.business.id)
        .then((res) => {
          this.switch_dialog = false;
          this.toast_msg = this.business.name + " was activated successfully";
          this.success_message = true;
          this.$store.state.user_initialised = false;

          router.push("/dashboard");
          location.reload();
          this.$store.commit("init_app");
        })
        .catch(() => {
          // this.error_msg = "Something went wrong, could not activate business";
          // this.error_message = true;
          this.activate_dlg = false;
        });
    },

    showMobileNotif() {
      const mobileReg =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      if (mobileReg.test(navigator.userAgent)) {
        this.isOnMobile = true;
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent.toLowerCase())) {
          this.mobileType = "Iphone";
        } else {
          this.mobileType = "Android";
        }
      } else {
        this.isOnMobile = true;
      }
    },

    /**
     * check network status and strength
     * and alert user
     */
    checkNetworkHealth() {
      const connection =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;

      if (connection) {
        let type = connection.effectiveType;

        function updateConnectionStatus() {
          if (navigator.onLine) {
            if (connection.effectiveType !== type) {
              if (connection.effectiveType === "2g") {
                store.state.networkStatus.message =
                  "You are on a slow connection, operations will take relatively long to complete ";
                store.state.networkStatus.show = true;
                store.state.networkStatus.color = "warning";
                store.state.networkStatus.timeOut = -1;
              } else {
                store.state.networkStatus.message =
                  "Your connection has been restored";
                store.state.networkStatus.show = true;
                store.state.networkStatus.color = "green";
                store.state.networkStatus.timeOut = 3000;
              }

              type = connection.effectiveType;
            }
          } else {
            store.state.networkStatus.message = "You are offline";
            store.state.networkStatus.show = true;
            store.state.networkStatus.timeout = -1;
            store.state.networkStatus.color = "red";
          }
        }

        connection.addEventListener("change", updateConnectionStatus);
      }
    },
  },
  created() {
    this.$vuetify.theme.isDark = localStorage.isDark === "true";
    if (this.$route.query.token) {
      localStorage.access_token = this.$route.query.token;
    }
    this.$store.commit("init_app");
  },

  mounted() {
    /**
     * listen for authentication for sessiond events from other tabs
     * @type {module:worker_threads.BroadcastChannel}
     */
    const channel = new BroadcastChannel("sessionChannel");
    channel.onmessage = (event) => {
      if (event.data.resetSession) {
        clearTimeout(store.state.idleTimer);
      }
    };

    /**
     * listen for authentication for sessions events from other tabs
     * @type {module:worker_threads.BroadcastChannel}
     */

    const AuthConfirmedchannel = new BroadcastChannel("AuthConfirmedchannel");

    AuthConfirmedchannel.onmessage = (event) => {
      if (event.data.authComfirmed) {
        store.state.idle_dialog = false;
      }
    };

    /**
     * listen for login events from other tabs
     * @type {module:worker_threads.BroadcastChannel}
     */

    const loginChannel = new BroadcastChannel("loginConfirmed");

    loginChannel.onmessage = (event) => {
      if (event.data.loginConfirmed) {
        if (["/auth/login", "/auth/signup"].includes(location.pathname)) {
          location.reload();
        }

        store.state.idle_dialog = false;

        clearTimeout(store.state.idleTimer);
      }
    };

    /**
     * listen for logout events from other tabs
     * @type {module:worker_threads.BroadcastChannel}
     */

    const logoutChannel = new BroadcastChannel("logoutConfirmed");

    logoutChannel.onmessage = (event) => {
      if (event.data.logoutConfirmed) {
        if (!["/auth/login", "/auth/signup"].includes(location.pathname)) {
          window.location = "/auth/login";
        }
      }
    };

    this.checkNetworkHealth();

    this.window = Window;
    this.showMobileNotif();
    this.idleLogout();
    this.$vuetify.lang.current = localStorage.lang
      ? localStorage.lang
      : this.$vuetify.lang.current;

    this.$vuetify.rtl = this.$vuetify.lang.current === "ar";
  },
  sockets: {
    connect() {
      // console.log("Connected to Built socket...");
    },
  },
};
</script>

<style>
.trim-text-no-padding {
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.logo-animation {
  -webkit-animation: fade-in 2.5s cubic-bezier(0.39, 0.575, 0.565, 1) 1s
    infinite both;
  animation: fade-in 2.5s cubic-bezier(0.39, 0.575, 0.565, 1) 1s infinite both;
  transition: 0.6s ease-in-out;
}

@-webkit-keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.bg-light {
  background-color: #f5f5f562 !important;
}

button.v-btn,
a.v-btn {
  text-transform: capitalize !important;
  text-decoration: none;
}

.theme--dark svg text {
  fill: white !important;
}

.theme--dark .apexcharts-legend-text {
  color: white !important;
  fill: white !important;
}

.hover-effect-light {
  background-color: whitesmoke;
  transition: all 300ms ease-out;
}

.hover-effect-dark {
  background-color: #565656;
  transition: all 300ms ease-out;
}

.theme--dark .v-label {
  color: whitesmoke !important;
}
</style>
